<template>
  <div class="card">
    <div class="imgCard">
      <img referrerpolicy="no-referrer" :src="value.thumbnail" alt="" v-if="!imgErr" @error="imgErr = true">
      <div v-else class="imgFallback" />
    </div>
    <div class="date">{{ convertDateUTC(value.event_start_date) }}</div>
    <div class="title pointer" @click="redirectUrl(value.slug)">
      {{ value.title }}
    </div>
    <div class="card-footer">
      <ShareSocial :link="redirectWebUrl + 'agenda/' + value.slug" />
    </div>
  </div>
</template>
<script>
import ShareSocial from './ShareSocial.vue'
export default {
  name: 'CardPotrait',
  components: {
    ShareSocial
  },
  data () {
    return {
      imgErr: false,
    }
  },
  props: {
    value: {
      required: true,
      default: {
        event_start_date: '',
        title: '',
        thumbnail: ''
      }
    }
  },
  computed: {
    redirectWebUrl () {
      return process.env.VUE_APP_BACK_HOME_URL
    }
  },
  methods: {
    redirectUrl (slug) {
      window.open(this.redirectWebUrl + 'agenda/' + slug)
    }
  }
}
</script>
<style lang="scss" scoped>
    .card {
        padding: 10px;
        height: 360px;
        display: flex;
        flex-direction: column;
        .imgCard {
          img {
            height: 240px;
            max-width: 100%;
            object-fit: contain;
            margin: 0 auto;
          }

          .imgFallback {
            width: 100%;
            height: 240px;
            background: #1e2b7b;
            border-radius: 8px;
          }
        }

        .card-footer {
          margin-top: auto;
          flex: 0 0 auto;
        }

        .date {
            font-size: 12px;
            margin-top: 15px;
        }

        .title {
            font-weight: 500;
            line-height: 1.2;
            font-style: italic;
            font-size: 16px;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;

            &:hover {
              color: $blue;
            }
        }
    }
</style>
